import { Amplify } from 'aws-amplify';
import config from '../aws-exports.json';
import { fetchAuthSession } from '../network/Auth';

export async function getRequestHeaders (headers) {
  return {
    headers: Object.assign({}, {}, headers)
  };
}

export async function createVerifierRequestHeaders (profileName) {
  const session = await fetchAuthSession();
  const tokenPayload = session.idToken?.payload;
  return {
    headers: Object.assign({}, {
      'Content-Type': 'application/json',
      'X-Tenant-Id': `${tokenPayload.logon.toUpperCase()}_${profileName}`,
      authorization: `bearer ${JSON.stringify({
            idToken: session.idToken?.jwtToken,
            accessToken: session.accessToken?.jwtToken,
            refreshToken: session.refreshToken?.token
          })}`
    }
    )
  };
}

export function configureAmplify (region, options = {}) {
  region = region || config.region;
  const appClient = JSON.parse(localStorage.getItem('tenant-appClient')) || undefined;
  const oauthRegion = appClient ? JSON.parse(localStorage.getItem('tenant-region')) : region;
  const redirectUrl = window.location.hostname === 'localhost' ? window.location.origin : config?.sso?.ssoRedirectDomain;
  const cognito = {
    allowGuestAccess: false,
    authenticationFlowType: 'USER_SRP_AUTH',
    loginWith: {
      email: true,
      oauth: {
        domain: config[oauthRegion].oauthDomain,
        scopes: [
          'email',
          'openid',
          'aws.cognito.signin.user.admin'
        ],
        redirectSignIn: [redirectUrl],
        redirectSignOut: [redirectUrl],
        responseType: 'code'
      }
    },
    identityPoolId: config[region].cognito.identitypool,
    region: config[region].cognito.region,
    userPoolId: config[region].cognito.userpool,
    userPoolClientId: options.userPoolWebClientId || appClient || config[region].cognito.webclient,
  };
  Amplify.configure({
    Auth: {
      Cognito: cognito
    }
  });
}

export function getStage () {
  return config.stage;
}

export function getApiOAuth2Endpoint () {
  const tenantRegion = JSON.parse(localStorage.getItem('tenant-region')) || undefined;
  if (!tenantRegion) return undefined;
  return config[tenantRegion].apiOAuth2Endpoint;
}

export function getApiUrl () {
  const tenantRegion = JSON.parse(localStorage.getItem('tenant-region')) || undefined;
  if (!tenantRegion) return undefined;
  return config[tenantRegion].apiUrl;
}

export function getRegion () {
  return config.region;
}

const sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay));

export async function executeWithRetry (callback, retries, attempt = 0) {
  try {
    // if (attempt < 3) throw new Error('test');
    return await callback();
  } catch (error) {
    if (attempt < retries) {
      await sleep(300);
      return await executeWithRetry(callback, retries, ++attempt);
    } else {
      throw error;
    }
  }
}
